import { MARKETING_TRACKING_PARAMS } from '../constants';
import type { TrackingParams } from '../types';

/** Campaign params only — SS burns affiliate tags at the first registration. */
export const getMarketingParams = (params: TrackingParams) => {
  const marketingParams: TrackingParams = {};

  MARKETING_TRACKING_PARAMS.forEach((param) => {
    if (params[param]) {
      marketingParams[param] = params[param];
    }
  });

  return marketingParams;
};
